export const PALETTE_THUMBNAIL_BG_COLOR = "#606060";
